import { render, staticRenderFns } from "./DaysSelect.vue?vue&type=template&id=42810f06&scoped=true&"
import script from "./DaysSelect.vue?vue&type=script&lang=js&"
export * from "./DaysSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42810f06",
  null
  
)

export default component.exports